// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","subheadline":"CityCopy_subheadline__jTk4f"};